import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import socket from '../../../helper/Socket';
import { getSessionById, getSessionState } from '../../../store/SessionSlice';
import { useAppSelector } from '../../../hooks';

const Session: React.FC<{ subTopicId: string }> = ({ subTopicId }) => {
  const dispatch = useDispatch();

  // Store
  const sessionState = useAppSelector(getSessionState);

  // State
  const [sessionId, setSessionId] = useState('');
  const [questionId, setQuestionId] = useState('');
  const { session } = sessionState;

  useEffect(() => {
    if (subTopicId) {
      socket.emit('join_session', { subTopicId });
    }
  }, []);

  useEffect(() => {
    socket.on('receive_session', (data) => {
      if (data.sessionId) {
        setSessionId(data.sessionId);
      }
    });
    socket.on('receive_question', (data) => {
      if (data.question) {
        setQuestionId(data.question);
      }
    });
  }, [socket]);

  useEffect(() => {
    if (sessionId) {
      dispatch(getSessionById(sessionId));
    }
  }, [sessionId, questionId]);

  useEffect(() => {
    if (session && sessionId && session._id === undefined) {
      setSessionId('');
    }
  }, [session]);

  return null;
};

export default Session;
